/**
 * Type Beauty Swiper bootstrap.
 * Loads the theme-vendored Swiper 12 UMD bundle once, then exposes TBSwiper helpers.
 * Use TBSwiper.whenReady / TBSwiper.create so inits never race the script load.
 */
(function (window, document) {
  'use strict';

  // Prefer theme assets (set by theme.liquid). Fall back to jsDelivr if missing.
  var CSS_HREF =
    window.__TB_SWIPER_CSS__ ||
    'https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.css';
  var JS_HREF =
    window.__TB_SWIPER_JS__ ||
    'https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.js';

  var loadPromise = null;
  var waiters = [];

  function loadCss() {
    if (document.querySelector('link[data-tb-swiper-bundle]')) return;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = CSS_HREF;
    link.setAttribute('data-tb-swiper-bundle', '1');
    document.head.appendChild(link);
  }

  function flushWaiters(Swiper) {
    window.__tbSwiperReady = true;
    var queue = waiters.splice(0, waiters.length);
    for (var i = 0; i < queue.length; i++) {
      try {
        queue[i](Swiper);
      } catch (err) {
        console.error(err);
      }
    }
    try {
      document.dispatchEvent(new CustomEvent('tb:swiper:ready', { detail: { Swiper: Swiper } }));
    } catch (e) {}
    return Swiper;
  }

  function loadBundle() {
    if (loadPromise) return loadPromise;

    loadCss();

    if (window.Swiper) {
      loadPromise = Promise.resolve(window.Swiper).then(flushWaiters);
      return loadPromise;
    }

    loadPromise = new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[data-tb-swiper-bundle]');
      if (existing) {
        if (window.Swiper) {
          resolve(window.Swiper);
          return;
        }
        existing.addEventListener('load', function () {
          if (window.Swiper) resolve(window.Swiper);
          else reject(new Error('Swiper bundle loaded but window.Swiper missing'));
        });
        existing.addEventListener('error', function () {
          reject(new Error('Failed to load Swiper bundle'));
        });
        return;
      }

      var script = document.createElement('script');
      script.src = JS_HREF;
      script.defer = true;
      script.setAttribute('data-tb-swiper-bundle', '1');
      script.onload = function () {
        if (window.Swiper) resolve(window.Swiper);
        else reject(new Error('Swiper bundle loaded but window.Swiper missing'));
      };
      script.onerror = function () {
        reject(new Error('Failed to load Swiper bundle'));
      };
      document.head.appendChild(script);
    }).then(flushWaiters);

    return loadPromise;
  }

  function get() {
    // Module list args are ignored — full bundle already includes all modules.
    return loadBundle();
  }

  function whenReady(callback) {
    if (typeof callback !== 'function') return loadBundle();
    if (window.__tbSwiperReady && window.Swiper) {
      try {
        callback(window.Swiper);
      } catch (err) {
        console.error(err);
      }
      return loadBundle();
    }
    waiters.push(callback);
    return loadBundle().catch(function (err) {
      console.error(err);
    });
  }

  function create(el, options) {
    return loadBundle().then(function (Swiper) {
      var target = el;
      if (typeof el === 'string') {
        target = document.querySelector(el);
      }
      if (!target) {
        return null;
      }
      if (target.swiper) {
        try {
          target.swiper.destroy(true, true);
        } catch (e) {}
      }
      // Safer defaults so taps on links inside carousels navigate on first click
      // instead of being treated as a micro-swipe (flicker / double-tap).
      var defaults = {
        threshold: 20,
        preventClicks: false,
        preventClicksPropagation: false,
        touchStartPreventDefault: false
      };
      var merged = Object.assign({}, defaults, options || {});
      var instance = new Swiper(target, merged);

      // If a tap lands on a link but Swiper swallowed the browser click, navigate manually.
      if (instance && typeof instance.on === 'function') {
        instance.on('tap', function (swiper, event) {
          try {
            var src = (event && (event.target || (event.detail && event.detail.target))) || null;
            if (!src || !src.closest) return;
            // Don't hijack interactive controls
            if (src.closest('button, input, select, textarea, label, [data-quickview-trigger], [data-wishlist-toggle]')) {
              return;
            }
            var link = src.closest('a[href]');
            if (!link) return;
            var href = link.getAttribute('href');
            if (!href || href === '#' || href.indexOf('javascript:') === 0) return;
            // Only force when Swiper marked the gesture as a non-click swipe cancel
            if (swiper && swiper.allowClick === false) {
              window.location.assign(link.href);
            }
          } catch (err) {}
        });
      }

      return instance;
    });
  }

  window.TBSwiper = {
    get: get,
    create: create,
    whenReady: whenReady,
    ready: function () {
      return loadBundle();
    }
  };

  /* Do not eager-load Swiper — sections call whenReady/create on demand */
})(window, document);
